module.exports = __webpack_public_path__ + "img/tuijian.bea660ec.jpg";